export default __webpack_public_path__ + "static/media/reloginBackground.746c4805.jpg";